export default {
    methods: {
        groupHasSelectedSubstances(group) {
            const substances = group && Array.isArray(group.substances) ? group.substances : []
            return substances.some(sub => sub && sub.substanceId)
        },
        groupHasNoSubstance(group) {
            const substances = group && Array.isArray(group.substances) ? group.substances : []
            return substances.some(sub => sub && sub.noSubstance)
        },
        allowNoSubstance(group) {
            if (this.requireSubstance) {
                return false
            }
            return !this.groupHasSelectedSubstances(group)
        },
        shouldShowAddSubstance(group) {
            return !this.groupHasNoSubstance(group)
        },
        hasUnfilledRows(declarations) {
            return (declarations || []).some(group => {
                const substances = Array.isArray(group.substances) ? group.substances : []
                return substances.some(substance => {
                    if (!substance) {
                        return false
                    }
                    if (substance.noSubstance) {
                        return false
                    }
                    if (!substance.substanceId) {
                        return true
                    }
                    const weight = substance.weight || {}
                    const hasFrom = weight.from !== null && weight.from !== undefined && weight.from !== ''
                    const hasTo = weight.to !== null && weight.to !== undefined && weight.to !== ''
                    return !hasFrom && !hasTo
                })
            })
        },
    },
}
